import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LicitacionService } from '../../../../service/licitacion.service';

@Component({
  selector: 'app-calificacion',
  templateUrl: './calificacion.component.html',
  styleUrls: ['./calificacion.component.css']
})
export class CalificacionComponent implements OnInit {
	private subscription: Subscription = new Subscription();
	RouteText : any;
	tituloseo: any;
	urlcanonicaseo: any;
	imagenseo: any;
	keywordsseo: any;
	addd = false;
	calificaciones!: any[];
	descripcionseo: any;
	toggle:boolean = true;
	editar = false;
	success= false;
	fail = false;
	isReadonly=false;
	parfiltros:any;
	estatusUpdate: any;
	CaliidUpda: any;
	calificacionUpdate: any;
	formupdate: any;
	p: number = 1;
	

	constructor( 
		private meta: Meta,
		private title: Title,
		private _seoService: SeoService,
		private router: Router,
		private _licitacionservice: LicitacionService,
		private _urlcanonicaservice: UrlcanonicaService
		) { 
			if((sessionStorage.getItem('token') == null || sessionStorage.getItem('token') == 'null')||(sessionStorage.getItem('user') == null || sessionStorage.getItem('user') == 'null')){
				this.router.navigate(['/licitaciones/administrador/login']);
			}

			this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
				this.RouteText = event;
				this.getSEO(event.url)
			});
		}

	getSEO(page: string) {
		this._seoService.getSEO(page).subscribe((resp: any) => {
			this.tituloseo = resp.titulo;
			this.descripcionseo = resp.descripcion;
			this.urlcanonicaseo = resp.urlcanonica;
			this.imagenseo = resp.image;
		
			this._urlcanonicaservice.createCanonicalLink();
			this.title.setTitle(this.tituloseo)
			this.meta.updateTag({name: 'description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:card',content: 'summary'})
			this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
			this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
			this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/login'})
			this.meta.updateTag({property: 'og:title',content: this.tituloseo})
			this.meta.updateTag({property: 'og:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
		});
	}

	ngOnInit(): void {
		this.getCalificaciones()
	}

	addCalificacion(){this.addd = true;}
	
	getCalificaciones() {
        this.subscription.add(
            this._licitacionservice.getcalificaciones().subscribe((resp: any) => {
				this.calificaciones = resp;
            })
        );
    }


	confirmacionAgregar(form: NgForm) {
		var insert = {
			Calificacion:form.value.calificacion,
			Descripcion:form.value.calificacion,
		}
		this.subscription.add(
            this._licitacionservice.postInsertCalificacion(insert, sessionStorage.getItem('token') ).subscribe((resp: any) => {
				form.reset();
				this.addd = false;
				this.getCalificaciones();
            })
        );
		
	}

	change(calificacion: any){
		this.estatusUpdate = calificacion.activo;
		this.calificacionUpdate = calificacion.calificacion;
		this.CaliidUpda = calificacion.id
		this.editar = true;
	}


	cancel() {
		this.editar = false;
		this.addd = false;
	}
	UpdateCalifo(form: NgForm) {
		this.formupdate = form.value;
		this.success= true;
		this.editar = false;
	}
	closeok() {
		if(this.formupdate.estatusUpdate == null || this.formupdate.estatusUpdate == 'null'){this.formupdate.estatusUpdate = false}
		var post = {
			Id: this.CaliidUpda,
			Calificacion : this.formupdate.calificacionUpdate,
			Descripcion : this.formupdate.calificacionUpdate,
			Activo: this.formupdate.estatusUpdate
		}
		this.subscription.add(
            this._licitacionservice.postUpdateCalificacion(post, sessionStorage.getItem('token') ).subscribe((resp: any) => {
				this.getCalificaciones();
				this.success= false;
				this.editar = false;
            })
        );
	}

	closefail() {
		this.success= false;
		this.editar = true;
	}
	////////////
}